import { FeedbackDialogParams } from '../components/InlineFeedbackDialog';
import { isFeatureEnabled } from 'owa-feature-flags';

export function shouldShowIntermediateFeedbackRibbon(
    feedbackDialogParams: FeedbackDialogParams
): boolean {
    if (isFeatureEnabled('inline-feature-feedback') && feedbackDialogParams) {
        if (
            (feedbackDialogParams.categories &&
                feedbackDialogParams.categories.length > 0 &&
                feedbackDialogParams.categories[0].uiString &&
                feedbackDialogParams.categories[0].uiString.length > 0) ||
            (feedbackDialogParams.ghostText && feedbackDialogParams.ghostText.length > 0)
        ) {
            return true;
        } else {
            console.warn(
                'Inline Feedback Dialog Error : Both the Text field placeholder and the Categories cannot be empty'
            );
        }
    }
    return false;
}
